import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolService {

  private baseApi = `${environment.baseApi}/catalog`

constructor(private http: HttpClient) { }

catalogoRol() {
  return this.http.get<any>(`${this.baseApi}/rol`).toPromise();
}

}
